(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, $, Promises) {
    'use strict';

    let iniciarVentaRecurrente = function (obj, status, xhr) {
        console.log('iniciarVentaRecurrente | ' + obj);
        if (obj.code == '0000') {
            Model.setPago(obj.response.formularioWondersoft);
            View.formularioPago(Message.Pago.ERROR_GENERAL);
        } else {
            View.formularioPago(Message.Pago.ERROR_GENERAL, true);
        }
    }


    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.clienteObtener = function (obj, status, xhr) {
        console.log('ClienteObtenerHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                Model.setCliente(obj);
                View.formularioDatosPersonales();
                break;
            case '1010':
                // Informacion del contacto no encontrada
                break;
            case '0001':
                logger && logger.fatal('ClienteObtenerHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('ClienteObtenerHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }



    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.iniciarVenta = function (obj, status, xhr) {
        switch (obj.code) {
            case '0000':
                var residencia = Model.getInputsBy("datos_personales", 'residencia').get().value;
                Model.Venta.Domicilio = obj.response.domicilioResponse;
                Model.Venta.esExtranjero = residencia == 'true' ? true : false;
                Model.setPago(obj.response.formularioWondersoft);
                View.formularioPago();
                break;
            case "4001":
                // Usuario no logeado
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case "4011":
                // Debes especificar un numero de documento
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '4040':
                // Error de duplicidad de tipo-nro de documento 
                var text = Helper.readCookie("usuario%5Fid") + ' -- Ya existe más de un cliente con este tipo y número de documento.'
                Analytics.error(text);
                logger && logger.error('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '0001':
                logger && logger.fatal('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            default:
                logger && logger.error('ClienteGuardarHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }
    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.clienteGuardar = function (obj, status, xhr) {
        console.log('ClienteGuardarHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                var residencia = Model.getInputsBy("datos_personales", 'residencia').get().value;
                Model.Venta.Domicilio = obj.response.domicilio;
                Model.Venta.esExtranjero = residencia == 'true' ? true : false;
                Model.setPago(obj.response.venta);
                View.formularioPago();
                break;
            case "4001":
                // Usuario no logeado
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case "4011":
                // Debes especificar un numero de documento
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '4040':
                // Error de duplicidad de tipo-nro de documento 
                var text = Helper.readCookie("usuario%5Fid") + ' -- Ya existe más de un cliente con este tipo y número de documento.'
                Analytics.error(text);
                logger && logger.error('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            case '0001':
                logger && logger.fatal('ClienteGuardarHandler | ' + obj.message, { Response: obj, Model: Model });
                Helper.showBlockMessageError("form-datos-personales-error");
                break;
            default:
                logger && logger.error('ClienteGuardarHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }



    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.clienteObtenerCrmId = function (obj, status, xhr) {
        console.log('ClienteCrmHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                break;
            case '0001':
                logger && logger.fatal('ClienteCrmHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('ClienteCrmHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.obtenerDatosFiliatorios = function (obj, status, xhr) {
        console.log('FiliatoriosHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                Model.setCliente(obj);
                //Controller.obtenerMontoACobrar(function () {
                View.formularioDatosPersonales();
                //});
                break;
            case '4010':
                // Informacion del contacto no encontrada                
            Service.mostrarError(Message.Usuario['INFORMACION_NO_ENCONTRADA'], Message.Analytics.Usuario['INFORMACION_NO_ENCONTRADA']);
                break;
            case '0001':
                logger && logger.fatal('FiliatoriosHandler |' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FiliatoriosHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.obtenerDatosFiliatoriosFormularioEnvio = function (obj, status, xhr) {
        console.log('FiliatoriosHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                //Model.setCliente(obj);
                //View.formularioDatosPersonales();
                Model.setCliente(obj);
                Model.setDomicilios(obj);

                //Model.setPlanAssets();

                View.formularioPosdatado(null, function () {
                    /* Seteo el primer domicilio como checked */
                    if (Model.getFirstDomicilio() !== false) {
                        Model.getInputsBy('datos_envio', 'id').set(Model.getFirstDomicilio().id)
                    }
                    Helper.eventosDatosEnvios();
                    Helper.carrito();
                    Helper.yaCompraste();
                });

                break;
            case '4010':
                // Informacion del contacto no encontrada                
            Service.mostrarError(Message.Usuario['INFORMACION_NO_ENCONTRADA'], Message.Analytics.Usuario['INFORMACION_NO_ENCONTRADA']);
                break;
            case '0001':
                logger && logger.fatal('FiliatoriosHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FiliatoriosHandler | No existe el codigo  (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.obtenerMontoACobrar = function (obj, status, xhr) {
        switch (obj.code) {
            case '0000':
                Model.setPlanMonto(obj.response);
                break;
            case '0001':
                logger && logger.fatal('CampanaHandler |' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('CampanaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.campaniaObtener = function (obj, status, xhr) {
        console.log('CampanaHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // OK
                break;
            case '0001':
                logger && logger.fatal('CampanaHandler |' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('CampanaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.existeMailUsuarioResponseHandler = function (obj, status, xhr) {
        console.log('MailHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0001':
                logger && logger.fatal('MailHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('MailHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.domicilioNormalizar = function (obj, status, xhr) {
        console.log('NormalizarHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0005':
                Analytics.formError('NormalizarHandler | ' + obj.message, { Response: obj, Model: Model });
                // Parametros invalidos
                break;
            case '0011':
                Analytics.formError('NormalizarHandler | ' + obj.message, { Response: obj, Model: Model });
                // Informacion del domicilio no encontrada
                break;
            case '0001':
                logger && logger.fatal('NormalizarHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            case '3022':
            case '3023':
            case '3024':
            case '3025':
                Analytics.formError('Paywall | domicilioNormalizar | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Service.mostrarError(obj.message);
                break;
            default:
                logger && logger.error('NormalizarHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                //throw new Error("No existe el tipo de estado");
                Service.mostrarError(obj.message);
        }
    }

    

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.ventaBonificada = function (obj, status, xhr) {
        console.log('ventaBonificada | ' + obj.code);
        switch (obj.code) {
            case '0000':
                if (!Helper.isEmpty(Model.PlanElegido)) {
                    Analytics.transaccionExitosa(Model.PlanElegido.nombre, Model.PlanElegido.precio, Model.Window.lastFlow );
                }

                if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) {
                    Service.actualizarCookies(Controller.postVentaBonificada);
                    LN.AppEvent.sendEvent('VENTA-OK');
                }
                break;
            case '0005':
                Analytics.formError('Paywall | domicilioNormalizar | Ingrese una tarjeta valida. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Helper.showBlockMessageError('error-tarjeta');
                break;
            case '0011':
                // Informacion del domicilio no encontrada
                Analytics.formError('Paywall | domicilioNormalizar | Información del domicilio no encontrada. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case '6001':
                // No se ha podido validar la tarjeta                
                Analytics.formError('Paywall | domicilioNormalizar | No se ha podido validar la tarjeta. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Helper.showBlockMessageError('error-tarjeta');
                break;
            case "6002":
                // No se ha podido generar la venta.
                Analytics.formError('Paywall | domicilioNormalizar | No se ha podido generar la venta. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case "6003":
                // No se ha podido encontrar el domicilio.
                Analytics.formError('Paywall | domicilioNormalizar | No se ha podido encontrar el domicilio. | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                View.domicilioNoExiste();
                break;
            case '0001':
                // No se ha podido generar la venta.
                logger && logger.fatal('ventaBonificada | Error inesperado', { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            case '6007':
                logger && logger.error('ventaBonificada | Error en wondersoft', { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('ventaBonificada | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.pagoObtenerTarjetasYBancos = function (obj, status, xhr) {
        console.log('BancoTarjetaHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0005':
                // Parametros invalidos
                break;
            case '0001':
                logger && logger.fatal('BancoTarjetaHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('BancoTarjetaHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.pagoValidar = function (obj, status, xhr) {
        console.log('PagoHandler | ' + obj.code);
        switch (obj.code) {
            case '0000':
                //
                break;
            case '0005':
                // Parametros invalidos
                break;
            case '0001':
                logger && logger.fatal('PagoHandler | ' + obj.message, { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.error('PagoHandler | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }


    // ==================================================
    // Manejador de errores http
    // ================================================== 
    Handler.failHandler = function (code) {
        console.log('FalloHandler | ' + code);
        switch (code) {
            case 500:
                Service.mostrarError(Message.Error['500'],Message.Analytics.Error['500']);
                break;                                  
            case 400:                                   
                Service.mostrarError(Message.Error['400'],Message.Analytics.Error['400']);
                break;                               
            case 401:                                
                Service.mostrarError(Message.Error['401'],Message.Analytics.Error['401']);
                break;                                
            case 402:                                 
                Service.mostrarError(Message.Error['402'],Message.Analytics.Error['402']);
                break;                                
            case 403:                                 
                Service.mostrarError(Message.Error['403'], Message.Analytics.Error['403']);
                break;
            case 200:
                ///
                break;
            case 'parsererror':
            Service.mostrarError(Message.Error['PARSER_ERROR'], Message.Analytics.Error['PARSER_ERROR']);
                break;
            case 'timeout':
            Service.mostrarError(Message.Error['TIMEOUT'], Message.Analytics.Error['TIMEOUT']);
                break;
            case 'abort':
            Service.mostrarError(Message.Error['ABORT'], Message.Analytics.Error['ABORT']);
                break;
            case 0:
                break;
            default:
                logger && logger.error('FalloHandler | No existe el error ( ' + code + ')');
            //throw new Error("No existe el error");
        }
    }

    // ==================================================
    // Manejador de errores Terminos y Condiciones
    // ================================================== 
    Handler.aceptaTyCErrores = function (code) {
        console.log('AceptaTCHandler | ' + code);
        //Service.mostrarError(Message.Error['GENERAL']);
        switch (Model.Window.currentStep) {
            case 'primer_acceso':
                if (code == "6003") View.domicilioNoExiste();
                else View.primerAcceso(Message.Error['GENERAL']);
                break;
            case 'ya_tiene_cuenta':
                View.yaTieneCuenta(Message.Error['GENERAL']);
                break;
            default:
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
        }
    }


    // ==================================================
    // Manejador de errores Validar Pines
    // ================================================== 
    Handler.validarPin = function (response) {
        console.log('ValidarPinHandler | ' + response.code);
        let credencialCat;
        var msj;
        switch (response.code) {

            case '0000':
                // Validacion del PIN OK
                Model.Usuario.esProvisorio = response.response.esProvisorio;
                Service.actualizarCookies(function () {
                    Analytics.clickValidarPin('Activación exitosa');
                    View.validarPinGracias();
                });
                break;
            case '6008':
            case '6011':
                // PIN NO EXISTE
                Analytics.clickValidarPin('Código de activación inválido');
                Helper.changeStatus($('#pin'), false, Message.Pines['PIN_INEXISTENTE']);
                break;
            case '6009':
                // PIN USADO
                Analytics.clickValidarPin('El código de activación que ingresaste ya ha sido utilizado');
                Helper.changeStatus($('#pin'), false, Message.Pines['PIN_USADO']);
                //View.validarPin(Message.Pines['PIN_USADO']);
                break;
            case '6010':
                // PIN VENCIDO
                Analytics.clickValidarPin('El código de activación ha vencido');
                View.validarPin(Message.Pines['PIN_VENCIDO']);
                break;
          case '0002':
            //Usuario no logeado, pide login/crear usuario.

            Helper.redirectToLoginWReturnAction('/validar-pin/' + Model.pin, 'vp');
            break;
            case '0201':
                // PIN ASOCIOADO A OTRO CRM
                Analytics.clickValidarPin('El código tiene asociado un CRM, que está asociado a otro usuario');
                View.validarPin(Message.Pines['PIN_ASOCIADO_A_OTRO_CRM']);
                break;
            case '07':
            case '08':
                // Ya tiene suscripcion
                Analytics.clickValidarPin('Tu cuenta de LA NACION ya tiene una suscripción digital activa');
                View.validarPin(Message.Pines['PIN_SUSCRIPCION_ACTIVA']);
                logger && logger.error('ValidarPinHandler | Ya tiene suscripcion digital activa', { Response: response, Model: Model });
                break;
            case '13':
            case '14':
            case '30':
            case '31':
                // Tarjeta asociada sin permisos, necesita desasociar.
                Analytics.clickValidarPin('Tu cuenta de LA NACION ya tiene una tarjeta asociada. Para continuar, es necesario que desvincules esa tarjeta desde Mi Cuenta');
                View.validarPin(Message.Pines['PIN_ASOCIADA']);
                logger && logger.error('ValidarPinHandler | El usuario ya tiene credencial asociada Classic', { Response: response, Model: Model });
                break;
            case '25':
            case '26':
                // Premium
                credencialCat = 'Premium';
            case '28':
                // Tarjeta Black o Premium, mensaje de acceso digital bonificado.
                Analytics.clickValidarPin('Tenes una tarjeta asociada en tu cuenta de LA NACION que te permite tener acceso digital bonificado');
                credencialCat = 'Black';
                msj = Message.Pines['PIN_ASOCIADA_BONIFICADO'];
                msj = msj.replace('{credencial}', credencialCat);
                View.validarPin(msj);
                logger && logger.error('ValidarPinHandler | El usuario ya tiene credencial Black o Premium', { Response: response, Model: Model });
                break;
            case '0001':
                logger && logger.fatal('ValidarPinHandler | ' + obj.message || '', { Response: obj, Model: Model });
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
            default:
                logger && logger.fatal('ValidarPinHandler | El codigo de respuesta no existe (' + obj.code || '' + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
                // Service.mostrarError(Message.Error['GENERAL']);
                break;
        }
    }

    // ==================================================
    // Manejador de errores Validar Pines Reenviar codigo
    // ================================================== 
    Handler.validarPinReenviar = function (response) {
        switch (response.code) {
            case '0000':

                break;
            default:
            Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
                break;
        }
    }

    Handler.posdatarDomicilio = function (response) {
        console.log('posdatarDomicilio | ' + response.code);

        switch (response.code) {
            case '0000':

                Model.Venta.Credencial = response.response;
                View.confirmacionCombo2();

                break;
            case '0005':
                // Parametros invalidos
                Analytics.formError('Paywall | domicilioCrear | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case '0011':
                // Informacion del domicilio no encontrada
                Analytics.formError('Paywall | domicilioCrear | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                break;
            case '3012':
            case '3013':
            case '3014':
            case '3015':
            case '3016':
            case '3017':
            case '3018':
            case '3019':
            case '3020':
            case '3021':
                Analytics.formError('Paywall | domicilioCrear | ' + obj.message, 'Respuesta: ' + JSON.stringify(obj) + ' | Cliente: ' + JSON.stringify(Model.Usuario));
                Service.mostrarError(obj.message);
                break;
            case '0001':
            default:
                logger && logger.fatal('posdatarDomicilio | ' + response.message, { Response: response, Model: Model });
                //Helper.cleanStatusInputs();
                //Helper.cleanInputs();
                Helper.enableNextButton();
                $('.atencion, .error-tarjeta').css('display', 'block');
                View.formularioEnvio();

                break;
        }
    }

    Handler.procesarPago = function (obj, status, xhr) {
        console.log('procesarPago | ' + obj.code);
        switch (obj.code) {
            case '0000':
                // Asigno el pin al modelo para mostrar en el gracias
                if (!Helper.isEmpty(obj.response.pin)) {
                    Model.pin = obj.response.pin;
                    Model.pinUrl = obj.response.pinUrl;
                    Model.pinDesc = obj.response.pinDesc;
                }
                Model.Usuario.esProvisorio = obj.response.esProvisorio;
                Controller.postVenta();
                break;
            case '0003':
                Model.Venta.Background = true;
                Model.Usuario.esProvisorio = obj.response.esProvisorio;
                Controller.postVenta();
                break;
            default:
                Controller.iniciarVenta(Model.Venta.Domicilio, null, iniciarVentaRecurrente);
        }
    }

    Handler.obtenerNewsletter = function (obj, resolve) {
        console.log('obtenerNewsletter | ' + obj.code);
        switch (obj.code) {
            case '0':
                Model.LoadNewsLetter(obj.response);
                Service.guardarNewsletter("servicios_ids=" + Model.Newsletter.join(','))
                    .then(resolve)
                    .catch(resolve);
                resolve();
                break;
            default:
                console.log("Analytics error");
                resolve();
        }
    }

    Handler.guardarNewsletter = function (obj, action, label) {
        console.log('guardarNewsletter | ' + obj.code);
        switch (obj.code) {
            case '0':
                console.log("Analytics");
                break;
            default:
                console.log("Analytics error");
        }
    }

})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, jQuery, LN.Promises);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/paywallHandler.js